export const groupToLetter = (group: number) =>
    ["A", "B", "C", "D", "E", "F"][group];
